import React from 'react';

import { LayoutInstance, ViewInstance } from '../../config/shared/types/page';
import { LayoutRenderer } from '../LayoutRenderer';
import { ViewRenderer } from '../ViewRenderer';

type ContentAreaProps = {
  contentArea: LayoutInstance | ViewInstance;
};

export const ContentArea = ({ contentArea: contentAreas }: ContentAreaProps) => {
  const contentArea = contentAreas;
  if (contentArea.type === 'layout') {
    return <LayoutRenderer layoutInstance={contentArea} />;
  }

  return <ViewRenderer viewInstance={contentArea} />;
};
